import type { DMsChannel } from './types'

/**
 * Whether a channel can hold DM conversations. Instagram only at launch, on
 * both login flows; Facebook Messenger and WhatsApp follow the channel
 * connection work. Decided by service here because the configuration
 * endpoint carries no DM capability yet; when it does, this reads it, the way
 * `supportsMentions` reads the mentions list.
 *
 * Narrowing matters because the `conversations` query fails as a whole when
 * any requested channel cannot serve DMs.
 */
export function supportsDms(channel: Pick<DMsChannel, 'service'>): boolean {
  return channel.service === 'instagram'
}
